<template>
    <div v-show="visible">
        <el-dialog title="发布" 
            element-loading-background = "rgba(255, 255,255,0.7)"
            :element-loading-text = "loadingText"
            v-loading="loading"
            :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="350px">    
            <el-form ref="form" :model="form" label-width="120px">

                <el-form-item  label="需要考核的教职">
                    <el-button @click="getMoreUser()">{{form.schoolCheckUsersLabel}}</el-button>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="save()">生成教职绩效单</el-button>
            </span>    
        </el-dialog>
        <!-- 人员弹出框 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../common/http'; 
    import userTransfer from '../../sys/user/UserTransfer.vue';
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                transferVisible:false,
                form:{
                    id:"",
                    deptId:"",
                    schoolCheckUsers:[],
                    schoolCheckUsersLabel: "",
                },
                loading:false,
                loadingText:"",
            }
        },
        components: {
            userTransfer
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.id=data.id;
                this.form.deptId=data.deptId;
                this.form.schoolCheckUsers=[];
                this.form.schoolCheckUsersLabel='请选择';
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){

                        if(this.form.schoolCheckUsers.length == 0){
                            this.$commonFn.showTip("需要考核的教职不可为空",3);
                            return;
                        }
                        
                        this.loading=true;
                        this.loadingText="生成中...";
                        let url= this.generateTeacherAssessUrl;
                        let data = {
                            id:this.form.id,
                            teacherIds:this.form.schoolCheckUsers.join(','), 
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.loading=false;
                        });
                    }
               });
            },
            getMoreUser(){
                this.transferVisible=true;
                this.$nextTick(() => {
                    if(this.form.schoolCheckUsers.length > 0){
                        this.$refs['userTransfer'].init(2,this.form.schoolCheckUsers,2,this.form.deptId);
                    }else{
                        this.$refs['userTransfer'].init(2,null,2,this.form.deptId);
                    }
                })
            },
            setUser(key,label){
                this.form.schoolCheckUsers = key;
                this.form.schoolCheckUsersLabel = key.length+"人";
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
   
</style>


// WEBPACK FOOTER //
// src/components/page/teacherAssess/template/UpdateTemplate.vue